import { createFileRoute } from '@tanstack/react-router';
import Forms from '@pages/Forms';

export const Route = createFileRoute('/forms/')({
  component: Forms,
});
